import { extractVideoId } from '@shared/src/utils/youtube';
import { PersistentAPIKey } from '@frontend/auction/src/helpers/PersistentAPIKey';

class VideoInfoService {
  get = async (url: string) => {
    const videoId = extractVideoId(url);

    if (!videoId) {
      console.log(`DEBUG:`, 'videoId', videoId);
      return null;
    }

    const apiKey = PersistentAPIKey.get();

    if (!apiKey) {
      console.log(`DEBUG:`, 'apiKey', apiKey);
      return null;
    }

    const result = await fetch(`/video-info/?k=${apiKey}&u=${url}`);

    if (result.status !== 200) {
      console.log(`DEBUG:`, 'status', result.status);
      return null;
    }

    const json = (await result.json()) as {
      result: {
        title: string;
        channel: string;
        duration: number;
        thumbnails: Record<
          'default' | 'medium' | 'high' | 'standard' | 'maxres',
          { url: string; width: number; height: number }
        >;
      } | null;
    };

    return json.result;
  };
}

export const VideoInfo = new VideoInfoService();
